import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=f2cea33c&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2cea33c')) {
      api.createRecord('f2cea33c', component.options)
    } else {
      api.reload('f2cea33c', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=f2cea33c&", function () {
      api.rerender('f2cea33c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25Grx6LyxZsZ0/JS/comp/IncreaseNumber.vue"
export default component.exports